import { ReactNode } from 'react';
import style from './BorderAndLabel.module.css';
import { colors } from '../../../../../colorVars';

type Props = {
  children: ReactNode;
  label: string;
  color:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  backgroundColor?:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  fontSize: string;
  borderRadius?: string;
  margin?: string;
  padding?: string;
  width?: string;
};

export const BorderAndLabel = ({
  children,
  label,
  color,
  backgroundColor = 'black',
  fontSize = '1rem',
  borderRadius = '0',
  margin,
  padding,
  width,
}: Props) => {
  return (
    <div
      className={style.outline}
      style={{
        color,
        backgroundColor: colors[backgroundColor],
        borderRadius,
        margin,
        padding,
        width,
        boxSizing: width ? 'border-box' : undefined,
      }}
    >
      <span
        className={style.label}
        style={{ backgroundColor: colors[backgroundColor], fontSize }}
      >
        {label}
      </span>
      {children}
    </div>
  );
};
